import * as React from 'react';
import {
	ActivityFeedIcon,
	ActivityFeedSolidIcon,
	DashboardIcon,
	DashboardSolidIcon,
	IconProps,
} from '@citrite/web-ui-component';
import { isNativeMobileClient } from 'Environment/launchResource/device';
import { useUserContext } from 'Workspace/UserContext';

export const HomeIcon = (props: IconProps) => {
	const { isIWSEnabled } = useUserContext();

	return isIWSEnabled && isNativeMobileClient() ? (
		<ActivityFeedIcon {...props} />
	) : (
		<DashboardIcon {...props} />
	);
};

export const HomeSelectedIcon = (props: IconProps) => {
	const { isIWSEnabled } = useUserContext();

	return isIWSEnabled ? (
		<ActivityFeedSolidIcon {...props} />
	) : (
		<DashboardSolidIcon {...props} />
	);
};
